

export class SettingsBO {
    isCCXWidget: boolean;
    id: string = "00000000-0000-0000-0000-000000000000";
    isWidgetKeyExpired : boolean;
    widgetAccessKeyBO : widgetInfo;

}   

export class widgetInfo {
    expireDate : string;
    accessKey: string;
}

export class saveSettingsBO {
    isCCXWidget: boolean;
    id: string = "00000000-0000-0000-0000-000000000000";
}   

export class IvrSettingBO {
    ccxAccessKey : string = "00000000-0000-0000-0000-000000000000";
    outBoundCallFlowId : string =  "00000000-0000-0000-0000-000000000000";
    smsFlowId :string =  "00000000-0000-0000-0000-000000000000";
    businessStartTime : string = null;
    businessEndTime : string = null;
    outBoundCallRetryDelay : number;
    outBoundMaxCallAttempts : number; 

}